module.exports = __webpack_public_path__ + "img/grenade.f1.c4f749fa.png";